/* KOFEA reviews: filters, sort, show more and photo dialog. */
if (!customElements.get('kofea-reviews')) {
  customElements.define('kofea-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      if (location.hash === '#kr-write') this.querySelector('.kr__write details')?.setAttribute('open', '');
      this.form = this.querySelector('.kr__filters');
      if (!this.form) return;
      this.list = this.querySelector('.kr__list');
      this.cards = [...this.querySelectorAll('[data-review]')];
      this.topic = '';
      this.limit = 6;
      this.dialog = this.querySelector('dialog');
      this.form.addEventListener('submit', event => event.preventDefault());
      this.form.addEventListener('input', () => { this.limit = 6; this.update(); });
      this.form.addEventListener('change', () => { this.limit = 6; this.update(); });
      this.form.addEventListener('reset', () => {
        this.topic = '';
        this.limit = 6;
        // Native form values reset after the reset event has finished.
        setTimeout(() => this.update(), 0);
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-topic')) {
          this.topic = this.topic === button.dataset.topic ? '' : button.dataset.topic;
          this.limit = 6;
          this.update();
        }
        if (button.hasAttribute('data-rating-filter')) {
          const field = this.form.elements.rating;
          field.value = field.value === button.dataset.ratingFilter ? '' : button.dataset.ratingFilter;
          this.limit = 6;
          this.update();
        }
        if (button.hasAttribute('data-clear')) this.form.reset();
        if (button.hasAttribute('data-more')) { this.limit += 6; this.update(); }
        if (button.hasAttribute('data-image')) {
          this.dialog.querySelector('img').src = button.dataset.image;
          this.dialog.showModal();
        }
        if (button.classList.contains('kr__close')) this.dialog.close();
      });
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.update();
    }
    update() {
      const fields = this.form.elements;
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const query = normalize(fields.search.value.trim());
      const rating = fields.rating.value;
      const matches = this.cards.filter(card =>
        (!query || normalize(card.textContent).includes(query)) &&
        (!rating || card.dataset.rating === rating) &&
        (!fields.photos.checked || card.dataset.photo === 'true') &&
        (!this.topic || card.dataset.topics.split(',').map(value => value.trim()).includes(this.topic))
      );
      matches.sort((a, b) => {
        const dateOrder = b.dataset.date.localeCompare(a.dataset.date);
        if (fields.sort.value === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating) || dateOrder;
        if (fields.sort.value === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating) || dateOrder;
        return dateOrder;
      });
      this.cards.forEach(card => { card.hidden = true; });
      matches.forEach((card, index) => { card.hidden = index >= this.limit; this.list.append(card); });
      this.querySelectorAll('[data-topic]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.topic === this.topic)));
      this.querySelectorAll('[data-rating-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ratingFilter === rating)));
      this.querySelector('.kr__result').textContent = `${matches.length} ${this.dataset.label} · ${Math.min(matches.length, this.limit)} ${this.dataset.shown}`;
      this.querySelector('.kr__empty').hidden = matches.length !== 0;
      this.querySelector('[data-more]').hidden = matches.length <= this.limit;
    }
  });
}
